import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

interface Glass {
  id: string;
  glazingCount: number;
  ug: number;
  interiorGlassThickness: number;
  exteriorGlassThickness: number;
  cavities: number[];
  name: string;
  type: string;
  thickness: number;
  category: string;
  uValue: number;
  gValue: number;
  lightTransmittance: number;
  coating: string;
  manufacturer: number;
  isLowE: boolean;
  region: number[];
  structure: string;
}
@Component({
  selector: 'app-edit-glass-list',
  templateUrl: './edit-glass-list.component.html',
  styleUrls: ['./edit-glass-list.component.scss'],
  standalone: false,
})
export class EditGlassListComponent {
  @Input() glasses: Glass[] = [];
  @Input() selectedGlass: Glass | null = null;
  @Input() showGlassName: boolean = false;
  @Output() glassSelected = new EventEmitter<Glass>();
  @Output() glassInfoClicked = new EventEmitter<Glass>();

  get availableCategories(): string[] {
    const categories = new Set<string>();
    this.glasses.forEach(glass => categories.add(glass.category || 'Other'));
    return Array.from(categories).sort();
  }

  getGlassesByCategory(category: string): Glass[] {
    return this.glasses.filter(glass => (glass.category || 'Other') === category);
  }

  getGlazingType(glazingCount: number): string {
    const types: Record<number, string> = {
      1: 'GLAZING_SINGLE',
      2: 'GLAZING_DOUBLE',
      3: 'GLAZING_TRIPLE',
      4: 'GLAZING_QUADRUPLE'
    };
    return types[glazingCount] || `${glazingCount}-glazingCount`;
  }

  onSelectGlass(glass: Glass): void {
    this.glassSelected.emit(glass);
  }

  onShowInfo(event: Event, glass: Glass): void {
    event.stopPropagation();
    this.glassInfoClicked.emit(glass);
  }

  getImageForGlazing(glazingCount: number): string {
    const imageMap: Record<number, string> = {
      1: 'assets/images/typen/Single.svg',
      2: 'assets/images/typen/Double.svg',
      3: 'assets/images/typen/Triple.svg',
      4: 'assets/images/typen/Quadruple.svg'
    };
    return imageMap[glazingCount] || 'assets/images/typen/Double.svg';
  }


}
